import React, { useState, useContext } from "react";
import { Row, Col, Card } from "react-bootstrap";
import classes from "./HomeComponent.module.css";
import MenuDisplayPage from "./MenuDisplayPage";
import LoginPage from "./LoginPage";
import PermissionContext from "../../Store/permission-context";
// import bg4 from "./Images/bg4.jpg";

const HomeComponent = () => {
  const PCtx = useContext(PermissionContext);
  const [FooterDetails, setFooterDetails] = useState([
    {
      header: "ABOUT US",
      body:
        "Contact us for your beverages, provisions, flour, softdrinks, food stuff, toiletries, home appliances etc. We sell both in wholesales and retails and our prices are very affordable.",
    },
    {
      header: "OUR ADDRESS",
      body: "Ilorin, Kwara State, Nigeria.",
    },
    {
      header: "CONTACT US",
      body: "PHONE NUMBER(S): 07016800278",
    },
    {
      header: " OUR SOFTWARE DEVELOPER",
      body: "APPLAUSE INFOTECH",
      tel: "TELEPHONE: 08033824233",
      email: "EMAIL: applausebiz@gmail.com",
    },
  ]);

  return (
    <Row>
      <Col md={12} sm={12} xs={12}>
        <Row>
          <Col md={12} sm={12} className="p-0 m-0" xs={12}>
            <Card>
              <Card.Body>
                <h4 className={classes.CompanyName}>ALAGUSIY IDEKUN MARKET</h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {PCtx.logged ? <MenuDisplayPage /> : <LoginPage />}
        <Row>
          <Col md={12} sm={12} xs={12}>
            <Card>
              <Card.Body>
                <Row>
                  {FooterDetails.map((ft, index) => (
                    <Col
                      md={3}
                      sm={12}
                      xs={12}
                      className={classes.TheFooter}
                      key={index}
                    >
                      <h5 className={classes.fth}>{ft.header}</h5>
                      <hr className="my-1 " />
                      <p className="text-justify">{ft.body}</p>
                      {ft.tel && <p className="text-justify">{ft.tel}</p>}
                      {ft.email && <p className="text-justify">{ft.email}</p>}
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default HomeComponent;
